const cookieNotification = {
    message: 'Bu sitede çerezler kullanılıyor',
    description: 'devamı',
    button: 'İyi',
};

export default cookieNotification;
